angular.module('callX').controller('DispositionStatusCtrl', ['$scope', '$rootScope','$modal', '$modalInstance', '$state', 'UserService', 'object', 'toaster', '$stateParams', function($scope,$rootScope, $modal,$modalInstance, $state, UserService, object,toaster, $stateParams) {

    $scope.obj = object;
    // console.log($scope.obj, "get object")
    $scope.status = $scope.obj.dispositionStatus,
    $scope.user_id = $scope.obj.user_Id;
    $scope.contact_id = $scope.obj.contactId;
    $scope.role = $scope.obj.role;
    $scope.str_number = $scope.obj.strNumber
    $scope.applicationSubmittedStatus = false;
    $scope.ticket = {};
    $scope.form = { notes: "" }; // Initialize the notes field
    $scope.showAnotherCallPrompt = false;

    $scope.filteredAgentNames = [];
    angular.forEach($rootScope.agentNames, function(agent) {
        if (agent.id != $stateParams.userId) {
            $scope.filteredAgentNames.push(agent);
        }
    });

    // console.log($scope.obj, "get object")

    if($scope.status === 'Application_Submitted'){
      $scope.status = $scope.obj.dispositionStatus.replace(/_/g, ' ');
    }else if($scope.status === 'No_Sale'){
      $scope.status = $scope.obj.dispositionStatus.replace(/_/g, ' ');
    }else {
      $scope.status;
    }


    $scope.selectDisposition = function(disposition_status, id) {
          // console.log("Highlight Selected ID:", disposition_status, id);
            var callDispositions = document.querySelectorAll('.calldisposition');
            callDispositions.forEach(function(disposition) {
                disposition.classList.remove('selected-disposition');
            });
            var selectedDisposition = document.getElementById(id);
            selectedDisposition.classList.add('selected-disposition'); 

            var selectedRadio = document.getElementById(id + 'Radio');
            selectedRadio.classList.add('selected-disposition');

            $scope.selectedDisposition = {
              value: disposition_status
            };
         // console.log($scope.selectedDisposition.value, "get value")
    };
   
    $scope.submit = function (status,call_disposition) {
      console.log('status,call_disposition )))))))))))',status,call_disposition)
        $modalInstance.close({
          status: status,
          call_disposition: call_disposition,
          notes: $scope.form.notes
        })
    }; 

    $scope.getAgentsArray = function(){
      var callbacks = {
            success: function (data) {
                $rootScope.agentNames = data;
             },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        UserService.getAgentDetails(callbacks);
    };
    $scope.getAgentsArray();

    $scope.cancel = function() {
      $modalInstance.close('cancel');
    };

  // $scope.confirmSubmit = function(answer) {
  //     if(answer === 'Yes'){
  //       console.log("yes ----------------")
  //       $modalInstance.close('Yes');
  //     }else if(answer === 'No'){
  //       console.log("no -----------------")
  //       $modalInstance.close('No');
  //     }
  // }


    $scope.submitTicketForm = function(){
        if(!$scope.ticket.title){
            toaster.pop('error', 'Title', 'Title field Required', 2000);
        }else if (!$scope.ticket.category) {
            toaster.pop('error', 'Category', 'Category field Required', 2000);
        }
        // else if (!$scope.ticket.status) {
        //     toaster.pop('error', 'Status', 'Status field Required', 2000);
        // }
        else if (!$scope.ticket.priority) {
            toaster.pop('error', 'Priority', 'Priority field Required', 2000);
        }else if(!$scope.ticket.message){
            toaster.pop('error', 'Message', 'Message field Required', 2000);
        }else if(!$scope.ticket.file){
            toaster.pop('error', 'Attachment', 'Attachment field Required', 2000);
        }
        else {
            var formData = new FormData();
            // formData.append('id',$scope.ticket.id);
            formData.append("agentId",$rootScope.userId);
            formData.append("callUUID","N/A");
            formData.append("phoneNumber","N/A");
            formData.append('title', $scope.ticket.title);
            formData.append('category', $scope.ticket.category);
            // formData.append('status', $scope.ticket.status);
            formData.append('priority', $scope.ticket.priority);
            formData.append('message', $scope.ticket.message);
            if ($scope.ticket.file) {
                formData.append('file', $scope.ticket.file);
            }
            // console.log(formData, "get support data")
            var callbacks = {
                success: function (data) {
                    toaster.pop('success', 'Success', 'Created Ticket Successfully', 2000);
                    $state.go('app.sales-agent.support');
                },
                failure: function (data) {
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                    $state.go('app.sales-agent.support');
                }
              };
            UserService.createSupport(formData,callbacks);
        }   
    }; 


    // disposition confirmation modal  
    $scope.openDispositionConfirmationModal = function (confirmStatus, applicationStatus) {
      $modalInstance.close(confirmStatus, applicationStatus);
    };

}]);